export default __webpack_public_path__ + "static/media/lords_hero.d1249f9b.jpg";